export default __webpack_public_path__ + "static/media/url_logo.d01bb113.svg";